<template>
  <b-row v-if="value.id">
    <b-col>
      <b-row class="mb-1 pb-0 walkthrough-item-input-row">
        <b-col
          cols="12"
        >
          <markdown-editor
            :value="value.content"
            @input="(content) => handleContentChanged(content)"
          />
          <b-button
            size="lg"
            variant="link mr-1"
            class="walkthrough-item-dropdown"
            @click="removeItem"
          >
            <i class="fa fa-fw fa-times" />
          </b-button>
        </b-col>
      </b-row>
      <photo-uploader
        :id="value.id"
        :photos="value.photos"
        :remove-photo="removePhoto"
        :upload-url="`/walkthrough_items/${value.id}/photos`"
        @on-photo-uploaded="(photo) => $emit('on-photo-uploaded', photo)"
        @on-destroy="(photo) => $emit('on-photo-destroyed', photo)"
      />
    </b-col>
  </b-row>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import errorToastMixin from '@/mixins/errorToastMixin';
import PhotoUploader from '@/components/shared/PhotoUploader.vue';
import MarkdownEditor from '@/components/shared/MarkdownEditor.vue';

export default {
  name: 'EditItem',
  mixins: [formMixin, errorToastMixin],
  components: {
    PhotoUploader,
    MarkdownEditor,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    inputRef: {
      type: String,
    },
  },
  methods: {
    handleContentChanged(newContent) {
      this.$emit('on-content-changed', newContent);
      if (newContent.length > 0) {
        this.$walkthroughsAPI
        .updateItem(this.value.id, { content: newContent })
        .then((walkthroughItem) => {
          this.$emit('input', walkthroughItem);
        });
      }
    },
    removeItem() {
      this.$swal({
        text: 'Are you sure you want to remove this item?',
        preConfirm: () => {
          return this.$walkthroughsAPI.destroyItem(this.value.id).catch((error) => this.displayErrorToast(error, {
            fallbackMessage: 'We\'ve experienced an issue trying to remove your item',
          }));
        },
      }).then((result) => {
        if (result.value) {
          this.$emit('on-destroy');
        }
        result.timer;
      });
    },
    removePhoto(photoId) {
      return this.$walkthroughsAPI.destroyItemPhoto(this.value.id, photoId);
    },
  },
};
</script>

<style #scoped>
   .walkthrough-item-dropdown {
    position: absolute;
    right: 0px;
    top: 0;
   }
</style>
